"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSendMessage = void 0;
var joi_1 = __importDefault(require("joi"));
var message_1 = require("../../message");
exports.ChatSendMessage = message_1.createMessage('chat/send', joi_1.default.object({
    message: joi_1.default.string().required().min(1).max(300),
    time: joi_1.default.number().required().min(1)
}))
    .withResponse();
